// Package Imports
import { queryOptions, useMutation } from '@tanstack/react-query'

// Core Imports
import type { TResponseError } from '@/core/types/axios'
import type { TMutation } from '@/core/types/react-query'
import type { TAdminListParams } from '@/core/lib/table-query'

// Module Imports
import {
  createAvatar,
  deleteAvatar,
  editAvatar,
  getAvatarDetail,
  getAvatarList,
} from '@/modules/avatar/avatar.service'
import type {
  TCreateAvatarRequest,
  TEditAvatarRequest,
} from '@/modules/avatar/avatar.types'

export const avatarListQueryOptions = (params: TAdminListParams) =>
  queryOptions({
    queryKey: ['avatarList', params],
    queryFn: () => getAvatarList(params),
  })

export const avatarDetailQueryOptions = (id: string) =>
  queryOptions({
    queryKey: ['avatarDetail', id],
    queryFn: () => getAvatarDetail(id),
    staleTime: 0,
  })

export function useCreateAvatar({
  onSuccess,
  onError,
}: TMutation<void, TResponseError, TCreateAvatarRequest>) {
  return useMutation<void, TResponseError, TCreateAvatarRequest>({
    mutationFn: createAvatar,
    onSuccess,
    onError,
  })
}

export function useEditAvatar({
  onSuccess,
  onError,
}: TMutation<void, TResponseError, TEditAvatarRequest>) {
  return useMutation<void, TResponseError, TEditAvatarRequest>({
    mutationFn: editAvatar,
    onSuccess,
    onError,
  })
}

export function useDeleteAvatar({
  onSuccess,
  onError,
}: TMutation<void, TResponseError, string>) {
  return useMutation<void, TResponseError, string>({
    mutationFn: deleteAvatar,
    onSuccess,
    onError,
  })
}
